













import { Component, Vue } from 'vue-property-decorator';

import { Store } from '@/enums/Store';

import { namespace } from 'vuex-class';

const APP = namespace(Store.APP);

@Component({
  name: 'error'
})
export default class ErrorComponent extends Vue {
  @APP.Getter('validErrors') errors!: Error[];
}
